import React, { useState } from "react";
import ContentBlock from "../ContentBlock";
import SearchBar from "./SearchBar";
import PaginatedList from "./PaginatedList";

const Publications = () => {
  const [artistId, setArtistId] = useState();

  const handleSearch = (selection) => {
    // handle clear event
    if (!selection) return setArtistId(null);

    setArtistId(selection.id);
  };

  const noResultsMessage = `
    No publications were found.
    Try clearing your search, or search for a different artist.
  `;

  return (
    <>
      <SearchBar onChange={handleSearch} />
      <ContentBlock>
        <PaginatedList
          artistId={artistId}
          noResultsMessage={noResultsMessage}
        />
      </ContentBlock>
    </>
  );
};

Publications.propTypes = {};

export default Publications;
